function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import clsx from 'clsx';
import { Card, CardActions, Link, Typography } from '@material-ui/core';
import { faCircle, faStar, faCodeBranch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStyles } from "./styles.js";
export const RepoCard = ({
  name,
  description,
  url,
  stars,
  forks,
  languageName,
  languageColor,
  aosProps,
  className,
  color = 'secondary'
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Link, _extends({}, aosProps, {
    href: url,
    rel: "noopener noreferrer",
    target: "_blank",
    underline: "none"
  }), /*#__PURE__*/React.createElement(Card, {
    elevation: 0,
    className: clsx(classes.card, className)
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.title,
    variant: "subtitle1",
    color: color,
    component: "h2",
    gutterBottom: true
  }, name), /*#__PURE__*/React.createElement(Typography, {
    className: classes.description,
    color: color,
    variant: "body1"
  }, description)), /*#__PURE__*/React.createElement(CardActions, null, /*#__PURE__*/React.createElement("div", {
    className: classes.infoContainer
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faCircle,
    color: languageColor
  }), /*#__PURE__*/React.createElement(Typography, {
    color: color,
    className: classes.info
  }, languageName)), /*#__PURE__*/React.createElement(Link, {
    href: `${url}/stargazers`,
    rel: "noopener noreferrer",
    target: "_blank",
    color: color,
    className: classes.infoContainer
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faStar,
    color: languageColor
  }), /*#__PURE__*/React.createElement(Typography, {
    color: color,
    className: classes.info
  }, stars)), /*#__PURE__*/React.createElement(Link, {
    href: `${url}/network`,
    rel: "noopener noreferrer",
    target: "_blank",
    color: color,
    className: classes.infoContainer
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faCodeBranch,
    color: languageColor
  }), /*#__PURE__*/React.createElement(Typography, {
    color: color,
    className: classes.info
  }, forks)))));
};
RepoCard.defaultProps = {
  aosProps: {
    'data-aos': 'fade-up',
    'data-aos-once': 'true'
  }
};
RepoCard.displayName = 'RepoCard';
export default RepoCard;